import React from 'react';
import { LinearProgress, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BreakfastColors } from '../../theme/BreakfastTheme';

interface BreakfastProgressBarProps {
  value: number; // 0-1
  color?: string;
  height?: number;
}

const StyledProgressContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'height',
})<{ height: number }>(({ height }) => ({
  height,
  backgroundColor: BreakfastColors.defaultFill,
  borderRadius: height / 2,
  overflow: 'hidden',
}));

const StyledLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'progressColor' && prop !== 'height',
})<{ 
  progressColor: string;
  height: number;
}>(({ progressColor, height }) => ({
  height,
  backgroundColor: 'transparent',
  borderRadius: height / 2,
  '& .MuiLinearProgress-bar': {
    backgroundColor: progressColor,
    borderRadius: height / 2,
  },
}));

export const BreakfastProgressBar: React.FC<BreakfastProgressBarProps> = ({
  value,
  color = BreakfastColors.primary,
  height = 6,
}) => {
  return (
    <StyledProgressContainer height={height}>
      <StyledLinearProgress
        variant="determinate"
        value={value * 100}
        progressColor={color}
        height={height}
      />
    </StyledProgressContainer>
  );
};
